import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof9: FaireReviewEntity = {
  token: "review_sof9",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_xxgtqj585r",
  reviewerName: "Chelsie",
  reviewerLocation: "Kearney, NE",
  stars: 5,
  reviewText: "We LOVE Softies! They are like wearing a nice, soft, buttery cloud. We've placed multiple orders.",
  reviewDate: "Feb 21, 2025",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
